import { useState } from "react";
import { AppLayout } from "../../components/layout/Header";
import { SharedButton, SharedCard, SharedProgressBar } from "../../components/shared";
import { useSellerState } from "../../js/state/sellerState";
import { SELLER_STEPS, sellerProgress, summarizeSellerSection } from "../../js/utils/sellerSteps";
import { prettyValue } from "../../js/utils/formatters";

export default function SellerPortfolioSummary() {
  const { seller, updatePortfolio, updateSeller } = useSellerState();
  const progress = sellerProgress(seller.portfolio);
  const submitted = Boolean(seller.portfolio.portfolioSummary?.submitted);
  const [message, setMessage] = useState(
    submitted ? "This portfolio was already marked as shared with your agent." : ""
  );

  function handleShare() {
    updatePortfolio("portfolioSummary", {
      submitted: true,
      submittedAt: new Date().toISOString(),
    });
    updateSeller({ status: "ready" });
    setMessage("Your seller portfolio is saved in this browser and marked as shared with your agent.");
  }

  const sections = SELLER_STEPS.filter((step) => step.key !== "portfolioSummary").map((step) => ({
    ...step,
    rows: summarizeSellerSection(seller.portfolio[step.key]),
  }));

  return (
    <AppLayout variant="seller" showSellerNav>
      <section className="card sendoff-banner" data-tour="seller-end">
        <h1>All Done! Time for Send-off.</h1>
        <div className="title-rule" />
        <p className="page-lead">
          Please be sure you have thoroughly reviewed your choices, then off to your Agent.
        </p>
      </section>

      {message ? <p className="confirm-banner">{message}</p> : null}

      <SharedCard style={{ marginBottom: "1rem" }}>
        <SharedProgressBar percent={progress.percent} label="Portfolio completeness" />
        <p className="field-hint" style={{ marginTop: "0.65rem" }}>
          {seller.name ? `${seller.name} · ` : ""}
          {seller.email || "No email saved yet"}
          {seller.phone ? ` · ${seller.phone}` : ""}
        </p>
      </SharedCard>

      {sections.map((section) => (
        <SharedCard key={section.key} title={section.label} style={{ marginBottom: "1rem" }}>
          {section.rows.length === 0 ? (
            <p className="field-hint">Nothing saved in this section yet.</p>
          ) : (
            <dl className="seller-summary-list">
              {section.rows.map((row) => (
                <div key={row.label}>
                  <dt>{row.label}</dt>
                  <dd>{prettyValue(row.value)}</dd>
                </div>
              ))}
            </dl>
          )}
        </SharedCard>
      ))}

      <div className="wizard-actions">
        <SharedButton variant="secondary" to="/seller/improvements">
          Back
        </SharedButton>
        <SharedButton variant="primary" onClick={handleShare}>
          {submitted ? "Update shared portfolio" : "Share with my agent"}
        </SharedButton>
      </div>
    </AppLayout>
  );
}
